import React from "react";

export default function Subjects() {
    return <div>Subjects</div>;
}
